<template>
  <a-sub-menu v-bind="$props" v-on="$listeners">
    <template slot="title">
      <a-icon :type="retIcon(subMenuInfo.meta.icon)" :style="{ fontSize: collapsed ? '23px' : '18px', marginRight:'5px'}"/>
      <span v-if="!collapsed" :title="subMenuInfo.meta.title">
        {{ subMenuInfo.meta.title }}
      </span>
    </template>

    <template v-for="menuInfo in subMenuInfo.children">
      <template v-if="!menuInfo.meta.hideInMenu">
        <sub-menu
          v-if="hasChild(menuInfo)"
          :key="menuInfo.path"
          :sub-menu-info="menuInfo"
        />
        <a-menu-item v-else 
        :key="menuItem(menuInfo).path"   
        @click="handleMenuItemClick(menuItem(menuInfo).path)">
          <!-- <i class="iconfont" :class="subMenuInfo.meta.icon"></i> -->
          <span :title="menuItem(menuInfo).meta.title">
            {{ menuItem(menuInfo).meta.title }}
          </span>
        </a-menu-item>
      </template>
    </template>
  </a-sub-menu>
</template>

<script>
import { Menu } from "ant-design-vue";
import mixin from "./mixin";
export default {
  name: "SubMenu",
  mixins: [mixin],
  props: {
    ...Menu.SubMenu.props,
    subMenuInfo: {
      type: Object,
      default: () => ({}),
    },
    iconSize: {
      type: Number,
    },
    collapsed: {
      type: Boolean,
    },
  },
  methods: {
    handleMenuItemClick(path) {
      this.$emit("MenuItemClick", path);
    },
    retIcon(e) {
      return e;
    },

  },
};
</script>
<style>
@import url("./Icon.less");
</style>
